import React, { useEffect } from "react";
import Modal from 'react-bootstrap/Modal';
import { Button } from "shards-react";

const defaultClasses = {
    header: "modal-header border-0 mx-2 mb-0 mt-1 py-0 justify-content-center",
    body: "modal-body text-center"
}

export const Popup = ( props ) => {
    const { show, toggle, title, message , showCloseBtn = true, timeout = null, size = "md" } = props;
    let timeoutId = null

    useEffect(() => {
        if(show) {
            timeoutId = setTimeout(() => {
                toggle();
            }, timeout ? timeout : 1500);
        }
    }, [show])

    const handleClose = () => {
        if(show)
            toggle();
        if(timeoutId)
            clearTimeout(timeoutId);
    }
  
    return (
      <>
        <Modal
          show={show}
          size={size}
          onHide={handleClose}
          backdrop={true}
          keyboard={false}
        >
          { title &&
            <Modal.Header className={defaultClasses.header} >
                { title }
            </Modal.Header>
          }

          { message && 
            <Modal.Body className={defaultClasses.body}>
                <h6>{ message }</h6>
            </Modal.Body>
          }

          { showCloseBtn &&
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cerrar
                </Button>
            </Modal.Footer>
          }

        </Modal>
      </>
    );
};